<template>
  <div class="c-media-box" @click="toArticlePage">
    <!-- <img class="media__img" :src="coverImageSrc" /> -->
    <p class="media__title">{{ data.title }}</p>

    <div class="media__btn">
      <pr-button arrow >瞭解更多</pr-button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';
import previewImg from '@/assets/img/global/img_preview.jpg';

export default defineComponent({
  name: 'MediaBox',
  components: {
    PrButton,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();
    const baseUrl = process.env.VUE_APP_BASE_URL;
    const coverImageSrc = props.data.path ? `${baseUrl}/${props.data.path}` : previewImg;

    const toArticlePage = () => {
      router.push({
        name: 'media',
        query: {
          id: props.data.id,
        },
      });
    };

    return {
      coverImageSrc,
      toArticlePage,

    };
  },
});
</script>
<style lang="scss" scoped>

.c-media-box {
  cursor: pointer;
  width: 100%;
  display: flex;
flex-direction: column;

}

.media {
  &__img {
    width: 100%;
    height: 300px;
    border-radius: 20px;
  }

  &__title {

    white-space: normal;
    @include font-style($c-main-brown, 20, 500, 1px, 28px);
    margin-top: 50px;
    height: 84px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  &__btn {
    margin-top: 40px;
  }
}

</style>
